var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-resolver',{scopedSlots:_vm._u([{key:"adminView",fn:function(){return [_c('dashboard-admin')]},proxy:true},{key:"clientView",fn:function(){return [_c('dashboard-client')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }